import { createTheme } from '@mui/material/styles'
import { FONT_FAMILY_PRIMARY } from '../constants/interaxColors'

/**
 * MUI Theme Configuration
 *
 * Sets default font family to Lexend Deca for all MUI Typography components
 * and other MUI components that use typography.
 */
export const muiTheme = createTheme({
  typography: {
    fontFamily: FONT_FAMILY_PRIMARY,
    // Set fontFamily for all typography variants to ensure consistency
    h1: {
      fontFamily: FONT_FAMILY_PRIMARY
    },
    h2: {
      fontFamily: FONT_FAMILY_PRIMARY
    },
    h3: {
      fontFamily: FONT_FAMILY_PRIMARY
    },
    h4: {
      fontFamily: FONT_FAMILY_PRIMARY
    },
    h5: {
      fontFamily: FONT_FAMILY_PRIMARY
    },
    h6: {
      fontFamily: FONT_FAMILY_PRIMARY
    },
    subtitle1: {
      fontFamily: FONT_FAMILY_PRIMARY
    },
    subtitle2: {
      fontFamily: FONT_FAMILY_PRIMARY
    },
    body1: {
      fontFamily: FONT_FAMILY_PRIMARY
    },
    body2: {
      fontFamily: FONT_FAMILY_PRIMARY
    },
    button: {
      fontFamily: FONT_FAMILY_PRIMARY
    },
    caption: {
      fontFamily: FONT_FAMILY_PRIMARY
    },
    overline: {
      fontFamily: FONT_FAMILY_PRIMARY
    }
  }
})
